import { SYSTEM_DATA_TYPES } from './types'
import { URL_PLAYBOOK_SETTINGS, URL_POLICIES } from '../../../constants'

export const BASE_PATH = URL_POLICIES + URL_PLAYBOOK_SETTINGS

export const BASIC_PATTERS_MAP = {
  [SYSTEM_DATA_TYPES.DATE]: [
    'MM/DD/YYYY',
    'MM/DD/YY',
    'DD/MM/YYYY',
    'DD/MM/YY',
    'YYYY/MM/DD',
    'MM-DD-YYYY',
    'DD-MM-YYYY',
    'YYYY-MM-DD',
    'DD.MM.YYYY',
    'DD.MM.YY',
    'DD-MMM-YYYY',
    'DD-MMM-YY',
    'MMM-YYYY',
    'MMM-YY',
    'DD-MMM',
    'MM/YYYY',
    'M/YYYY',
    'MM/YY',
    'M/YY',
    'MMM DD, YYYY',
    'MMM DD, YY',
    'MMM Dth, YYYY',
    'MMM Dth, YY',
    'DD MMM, YYYY',
    'DD MMM, YY',
    'Dth MMM, YYYY',
    'Dth MMM, YY',
    'MONTH Dth, YYYY',
    'MONTH Dth, YY',
    'MONTH DD, YYYY',
    'MONTH DD, YY',
    'Dth MONTH, YYYY',
    'Dth MONTH, YY',
    'DD MONTH, YYYY',
    'DD MONTH, YY'
  ]
}
